function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTimeTimerFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.988 27.934c5.749 0 10.345-4.564 10.345-10.116 0-5.551-4.596-10.115-10.345-10.115-5.75 0-10.345 4.564-10.345 10.115 0 5.552 4.596 10.116 10.345 10.116zm12.345-10.116c0 6.692-5.527 12.116-12.345 12.116-6.818 0-12.345-5.424-12.345-12.116 0-6.691 5.527-12.115 12.345-12.115 6.818 0 12.345 5.424 12.345 12.115zM19.621 4.066h-7.267v-2h7.267v2zM26.191 5.961l2.85 2.85-1.415 1.414-2.849-2.85 1.414-1.414z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.988 10.21h2v6.608h4.89v2h-6.89V10.21z",
    fill: props.color
  }));
}

export default SvgIconTimeTimerFilled;